import React, { useCallback } from 'react';

import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import { useStorePackRosterFilter } from '@modules/advancement/packRoster/duck/hooks';
import { showSubUnitsSel } from '@modules/advancement/packRoster/duck/selectorsTyped';
import { setShowSubUnits } from '@modules/advancement/packRoster/duck/slice';
import { Button } from '@shared/components';

import { setShowMemberTypes } from '../../../packRoster/duck/actions';
import {
  approvedSubUnitsSel,
  isSubUnitAllowedSel,
  subUnitTypeNameSel,
} from '../../duck';

const GroupSubUnitButton = () => {
  const dispatch = useDispatch();
  const showSubUnits = useSelector(showSubUnitsSel);
  const subUnitTypeName = useSelector(subUnitTypeNameSel);
  const isSubUnitAllowed = useSelector(isSubUnitAllowedSel);
  const approvedSubUnits = useSelector(approvedSubUnitsSel);

  const storePackRosterFilter = useStorePackRosterFilter();

  const handleOnClick = useCallback(() => {
    dispatch(setShowMemberTypes(false));
    storePackRosterFilter({
      showSubUnits: !showSubUnits,
    });
    dispatch(setShowSubUnits({ show: !showSubUnits }));
  }, [dispatch, showSubUnits, storePackRosterFilter]);

  return isSubUnitAllowed && approvedSubUnits.length > 0 ? (
    <Button
      color="white"
      ghost
      noBorder
      onClick={handleOnClick}
      size="small"
      uppercase={false}
    >
      <FormattedMessage
        id={`packRoster.GroupSubUnitButton.${subUnitTypeName}`}
      />
    </Button>
  ) : null;
};

export default GroupSubUnitButton;
